import CryptoJS from "crypto-js";
//解密啊
const decrypt = (data: any) => {
  if (!data) return data;
  try {
    const aesKey = "651cc172938d5b7799a23ac245e539a6";
    const key = CryptoJS.enc.Utf8.parse(aesKey);
    let iv = "35e5cd2d684e5c65";
    iv = CryptoJS.enc.Utf8.parse(iv);
    let decrypted = CryptoJS.AES.decrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    let result = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    return result;
  } catch {
    return data;
  }
};
export default decrypt;
